import { foldersRoot } from "../../mocks/dashboard";
import { IPlanarFolder, iterateFolderChildren } from "../../pages/dashboardPage/components/fullAnalysis/FSPlanarize";
import { IAnalysisFolder } from "../../pages/dashboardPage/components/fullAnalysis/IAnalysisFolder";
import { IFileProvider } from "./IFileProvider";
import { getFolders, postFolder, deleteFolder, putFolder } from "../folderApi";
import gicon from '../../assets/files/gdrive.svg';
import analysisIcon from '../../assets/files/analysis-icon.svg';
import folderImgDefault from '../../assets/folder-a.svg';

const iconMap = {
    'analysis': analysisIcon
}

export class ServerFileProvider implements IFileProvider{
    public onChange: (provider: IFileProvider)=>void;
    public onReady: ()=>void;
    public onAuthError?: (error: any) => void;
    public crumbs: Array<IAnalysisFolder> = [];
    private folders: Array<IPlanarFolder>;
    private rootId: string;
    private rootName: string;
    //protected _meta: Record<string, {position: {x: number, y: number}}> = {};

    constructor(rootId?:string, rootName?: string){
        this.rootId = rootId;
        this.rootName = rootName || 'root';
        Promise.resolve(true).then(()=>this.onReady?.());
    }

    get providerName(){
        return '';
    }

    /*get meta(){
        return this._meta;
    }*/

    async connect(){

    }

    private async _loadFolders(){
        const response = await getFolders();
        const folders = await response.json();
        this.folders = folders;
        return folders;
    };

    protected filterFolders(folders: IPlanarFolder[]): IPlanarFolder[]{
        return folders;
    }

    async getFiles(_folderId?: string, aliasName?: string){
        const folders: Array<Record<string, IPlanarFolder>> = await this._loadFolders();
        const _foldersArray: Array<IPlanarFolder> = folders.map(it=>{
            const id = Object.keys(it)[0];
            return {
                ...it[id],
                date: new Date(it[id].date),
                id
            }
        });//.filter(it=>it.type != 'meta');
        const foldersArray = this.filterFolders(_foldersArray);

        /*const metaFiles = foldersArray.filter(it=>it.type == 'meta');
        this._meta = {};
        metaFiles.forEach(it=>{
            const metaFixedType = it.fileData as any as Record<string, {position: {x: number, y: number}}>;
            if (metaFixedType){
                this._meta = {...this.meta, ...metaFixedType}
            }
        })*/

        const folderId = _folderId || this.rootId;
        const parent = foldersArray.find(it=>it.id == folderId);
        const children = foldersArray.filter(folder=>{
            return folder.parent == folderId || (!folderId && !folder.parent);
        }).map(it=>{
            return {
                ...it,
                iconIndex: it.type === 'folder' ? (it.iconIndex !== undefined ? it.iconIndex : 0) : undefined,
                avatarUrl: it.type !== 'folder' ? (it.avatarUrl || iconMap[it.name?.split('.')[1] as keyof typeof iconMap] || '') : undefined,
            }
        });

        const resultFolder: IAnalysisFolder = {
            name: aliasName || ((!_folderId || !parent)  ? this.rootName : parent.name),
            id: folderId,
            date: new Date(),
            fileData: parent?.fileData,
            type: parent?.type || 'folder',
            linkProvider: this.providerName,
            iconIndex: parent?.iconIndex || 0,
            folderItems: children as any as IAnalysisFolder[]
        }
        console.log(resultFolder);

        const crumbIndex = this.crumbs.findIndex(it=>it.id == folderId || (!folderId && !it.id));
        if (crumbIndex != -1 && this.crumbs.length !=0){
            this.crumbs = this.crumbs.slice(0, crumbIndex + 1);
        } if (crumbIndex == this.crumbs.length-1 && this.crumbs.length !=0){
            this.crumbs[crumbIndex] = resultFolder;
        } else {
            this.crumbs.push(resultFolder);
        }
        this.onChange(this);
        return resultFolder;
    }

    async createFile (file: File, folderId: string){

    }

    async createFolder (folder: IAnalysisFolder, folderId: string){
        return postFolder({
            name: folder.name,
            parent: folderId || this.rootId,
            link: folder.link,
            fileData: folder.fileData,
            linkProvider: folder.linkProvider,
            iconIndex: folder.iconIndex || 0,
            type: folder.type,
            date: folder.date.toISOString()
        }).then(async res=>{
            if (!res || !res.ok) { console.error('createFolder failed:', res?.status); return; }
            return this.getFiles(folderId);
        }).then(()=>{});
    }

    async deleteFile (fileId: string){
        return deleteFolder(fileId).then(async res=>{
            if (!res || !res.ok) { console.error('deleteFolder failed:', res?.status); return; }
            return this.getFiles(this.crumbs[this.crumbs.length -1].id);
        }).then(()=>{});
    }

    async updateFile(file: IAnalysisFolder){
        // this.folders holds raw API items: [{"-FirebaseId": {data}}, ...]
        // Find the matching raw item by key, then merge its data with the updates
        const rawFound = (this.folders as any[]).find(it => Object.keys(it)[0] === file.id);
        const foundData: IPlanarFolder | null = rawFound
            ? { id: Object.keys(rawFound)[0], ...rawFound[Object.keys(rawFound)[0]] }
            : null;

        return putFolder({
            name: file.name,
            iconIndex: file.iconIndex ?? foundData?.iconIndex ?? 0,
            fileData: file.fileData ?? foundData?.fileData,
            parent: file.parent ?? foundData?.parent,
            type: file.type ?? foundData?.type ?? 'folder',
            date: (file.date instanceof Date ? file.date : new Date()).toISOString(),
            link: file.link ?? foundData?.link,
            linkProvider: file.linkProvider ?? foundData?.linkProvider,
        }, file.id).then(async res=>{
            if (!res || !res.ok) {
                const body = await res?.text().catch(() => '');
                console.error('putFolder failed:', res?.status, body);
                return;
            }
            return this.getFiles(this.crumbs[this.crumbs.length -1].id);
        }).then(()=>{});
    };
}